import { Bill } from '@melio/platform-api';
import Big from 'big.js';

export const getExpectedBalance = (bill: Bill, amountToPay?: string) => {
  const expectedBalance = Big(bill.balance)
    .minus(Number(amountToPay || 0))
    .toNumber();
  return expectedBalance;
};
